<template>
  <div class="relationWe">
<!--    <div>-->
<!--      <otherNav></otherNav>-->
<!--    </div>-->
    <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"></breadcrumb>
    <div class="main-row contain">
      <div class="col col-xlg-12 col-sm-12 relationWe-item">
        <template v-if="tableData.length>0">
        <h4 class="item-h4" style="text-align: center">{{this.tableData[0].title}}</h4>
          <div class="ql-container">
            <p class=" pre ql-snow ql-editor content-detail  content" v-html="tableData[0].content"></p>
          </div>
<!--          <div class="content" v-html="this.editorText" style="text-align: left"></div>-->
<!--          <div  v-for="item in this.editorImg" class="editorImg">-->
<!--            <img :src="item" alt="">-->
<!--          </div>-->
          <!-- <el-table
              :data="tableData"
              style="width: 100%">
            <el-table-column
                pr prop="title"
                label=""
                show-overflow-tooltip
                style="text-align: left">
              <template slot-scope="scope">
                <router-link class="list-title" :to="'/detail/'+ scope.row.id+'/'+'relationWe'"
                             :detailId="scope.row.id">{{scope.row.title }}</router-link>
              </template>
            </el-table-column>
            <el-table-column
                prop="createTime"
                label=""
                width="150">
            </el-table-column>
          </el-table>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="totalPage">
          </el-pagination> -->
        </template>
        <el-empty description="没有找到数据" style="width: 20%;margin: 0 auto" v-else></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import otherNav from '@/components/navBar/otherNav'
import breadcrumb from '@/components/breadcrumb/index'
import { fetchList } from '@/network/help/problem'
export default {
  name: "relationWe",
  components: { breadcrumb, otherNav },
  data() {
    return {
      path: '',
      name: '',
      childName:'',
      childPath:'',
      pageSize: 10,
      page: 1,
      totalPage: 0,
      tableData: [],
      type: 'relationWe',
      formInline: {},
      editorText: '',
      editorImg: []
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '帮助'
    })
  },
  mounted() {
    this.getList()
    this.$nextTick(() => {

    })
  },

  created() {
    this.childName = '联系我们'
    this.childPath = this.$route.path
  },
  methods: {
    getList() {
      fetchList(Object.assign({
        current: this.page,
        size: this.pageSize,
        type: this.type
      })).then(response => {
        this.tableData = response.data.data.records
        this.totalPage = response.data.data.total
        this.getEditorText(this.tableData[0].content)
      })
    },
    handleSizeChange(val){
      this.pageSize = val
      this.page = 1
      this.getList()

    },
    handleCurrentChange(val){
      this.page = val
      this.getList()
    },
    openDetail(id){
      window.open('http://192.168.0.116:8887/information?id='+id,'_blank')
    },
    onSubmit() {

    },
    handleSelect(key, keyPath) {
      this.$router.push({path:key}).catch(err => {
        // console.log(err)
      })
    },
    getEditorText(str){
      this.editorText = str.replace(/<\/?(img|table)[^>]*>/g, "")
      // console.log(this.editorText)
      // this.editorText = str.replace(/<[^>]+>/g, "")
      return this.editorText
    },
    fn(str) {
      str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
        this.editorImg.push(capture)
      })
      return  this.editorImg
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/relationWe";
::v-deep .el-pagination {
  padding: 20px 5px !important;
  text-align: center;
}
</style>